import { render, staticRenderFns } from "./RoleGrantPermission.vue?vue&type=template&id=7ab9466c&scoped=true&"
import script from "./RoleGrantPermission.vue?vue&type=script&lang=js&"
export * from "./RoleGrantPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab9466c",
  null
  
)

export default component.exports